import { createContext } from "react";

export type WizardDirection = "forward" | "backward";

export type WizardStepMeta = {
  name: string;
  title?: string;
  subtitle?: string;
};

export type WizardState = {
  activeStep: string;
  canGoBack: boolean;

  /** step names in mount order */
  steps: string[];

  activeStepMeta: WizardStepMeta | undefined;
  direction: WizardDirection;
};

export type WizardActions<TStepName extends string = string> = {
  /** appends to history, back() returns here */
  push: (step: TStepName) => void;
  /** alias of push, { replace: true } swaps the current entry instead */
  goTo: (step: TStepName, options?: { replace?: boolean }) => void;
  back: () => void;
  next: () => void;
  prev: () => void;
  /** clear history and return to initialStep */
  reset: () => void;
  /**
   * internal method called by Wizard.Step on mount, returns an unregister
   * cleanup
   */
  registerStep: (meta: WizardStepMeta) => () => void;
};

// Split so that action-only consumers don't re-render on navigation, actions
// must be referentially stable. useWizard() asserts non-null.
export const WizardStateContext = createContext<WizardState | null>(null);
export const WizardActionsContext = createContext<WizardActions | null>(null);

// The enclosing Wizard.Step's own meta. Unlike activeStepMeta it never
// changes on navigation, so a pane exiting under AnimatePresence keeps its
// own title/subtitle instead of re-rendering with the incoming step's.
export const WizardStepMetaContext = createContext<WizardStepMeta | null>(null);
